// extracted by mini-css-extract-plugin
export default {"container":"CatchErrorBoundary_container__SP4qb","button":"CatchErrorBoundary_button__VzwnN"};